import { ListHeaderFilterInput, ListHeaderFilterContainer } from '@/components/List'

import { useTexts } from './hooks/useTexts'
import { useFilter } from './hooks/useFilter'

export function Filter() {
  const { query, setQuery, editing, noEntries } = useFilter()

  const texts = useTexts()

  const disabled = editing || noEntries

  return (
    <ListHeaderFilterContainer>
      <ListHeaderFilterInput
        placeholder={texts.filterPlaceholder}
        disabled={disabled}
        setQuery={setQuery}
        query={query}
      />
    </ListHeaderFilterContainer>
  )
}
